import store from "../store";
import baseService from "../services/base.service";
import { getPrimaryPropertyImage } from '../utils/files'
import { FileSize } from "../constant/file-size";

//actions
import { setLoadingRecommendedProperties, setPropertyDetailsData, setLoading, setRecommendedPropertiesData } from '../actions/property-details'

//utils
import {getFavorites} from './favorites'
import {isLoggedIn} from './user'
import {getAllBasket} from './my-basket'
import {getPropertyPrice} from './search-properties'

//devextreme
import notify from 'devextreme/ui/notify';

let controller;

const setPropertyDetails = async (id, navigate) => {
  try {
    await store.dispatch(setLoading(true))
    if (controller)
      controller.abort()

    controller = new AbortController();
    const url = `${process.env.REACT_APP_PROPERTY_API_ENDPOINT}/api/v1/dashboard/${id}/details`;
    await baseService.get(url, {
      method: 'GET',
      withCredentials: false,
      headers: {
        'Access-Control-Allow-Origin': `${process.env.PUBLIC_URL}`,
        'Content-Type': 'application/json',
      },
      signal: controller.signal
    }).then(async ({ data }) => {
      if (!data) {
        navigate("/property-not-found", { state: { id } });
      } else {
          let floorsInCart = null;
          if (isLoggedIn()) {
              floorsInCart = await checkIfInCart(id)
          } 
        let supplierPropertyRates = data.supplierPropertyRates?.map(item => {
          let checkIfIsInTheCart = floorsInCart?.filter(floor => floor  === item.floorPlanTypeId)
            return {
              ...item,
              addedToCart: checkIfIsInTheCart?.length > 0 ? true : false
            }
        })
        let formattedData = {
          ...data,
          supplierPropertyRates: supplierPropertyRates
        }
        store.dispatch(setPropertyDetailsData(formattedData))
        setTimeout(async function() {
          let price = await getPropertyPrice(data.address.latitude,data.address.longitude,id)
          store.dispatch(setPropertyDetailsData({...formattedData,rate: price}))
          setTimeout(function() {
            setRecommendedProperties(data.address.latitude,data.address.longitude,id)
          }, 3000);
        }, 3000);
      }
    }).finally(() => {
      store.dispatch(setLoading(false))
    })
      .catch(error => {
        
        store.dispatch(setPropertyDetailsData(null))
        store.dispatch(setLoading(false))
      })
  } catch (error) {
    store.dispatch(setPropertyDetailsData(null))
    store.dispatch(setLoading(false))
  }
}

const checkIfInCart = async (propertyId) => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/propertycart/check-if-added?propertyId=${propertyId}`;
    
    let response = await baseService.get(url, {
        method: 'GET',
        withCredentials: false,
        headers: {
           'Access-Control-Allow-Origin': `${process.env.PUBLIC_URL}`,
            'Content-Type': 'application/json',
        }
    })
    return response?.data
}

const setRecommendedProperties = async (latitude, longitude, currentId) => {
  try {
    if (controller)
      controller.abort()

    controller = new AbortController();
    store.dispatch(setLoadingRecommendedProperties(true))

    let radius = `&Radius=20`
    let geometry = `Latitude=${latitude}&Longitude=${longitude}`
    let pagination = `&skip=0&take=6`
    let floors = ''
    let allFloorPlans = store.getState().dictionary.floorPlanTypes
    allFloorPlans.forEach(type =>
      floors += `&FloorPlans=${type.id}`
    )
    let dataFavorites = await getFavorites()
    const url = `${process.env.REACT_APP_PROPERTY_API_ENDPOINT}/api/v1/search/list?${geometry}${radius}${floors}${pagination}`;
    await baseService.get(url, {
      method: 'GET',
      //mode: 'no-cors',
      withCredentials: false,
      headers: {
        //'Access-Control-Allow-Origin': true,
        'Content-Type': 'application/json',
      },
      signal: controller.signal
    }).then(({ data: { data } }) => {
      let favoriteIds = dataFavorites.map(item => item.id)

      let recommendedProperties = data.filter(item => item.metisId.toString() !== currentId).filter((item, index) => index < 5).map(
        property=>{
        let likeId = dataFavorites.filter(item => item.propertyId === property.id)
        return {
          ...property,
            isLiked: favoriteIds.includes(property.id),
            likeId: likeId[0]?.id,
            imageUrl: getPrimaryPropertyImage(property.id, FileSize.Large)
        }
      })
      store.dispatch(setRecommendedPropertiesData(recommendedProperties))
    }).finally(() => {
      store.dispatch(setLoadingRecommendedProperties(false))
    })
      .catch(error => {
        store.dispatch(setRecommendedPropertiesData([]))
        store.dispatch(setLoadingRecommendedProperties(false))
      })
  } catch (error) {
    store.dispatch(setRecommendedPropertiesData([]))
    store.dispatch(setLoadingRecommendedProperties(false))
  }

}
const postPropertyToCart = async (floorId,propertyId) => {
  try {
    if(isLoggedIn())
    {
      if(floorId && propertyId)
      {
        const url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/propertycart`;
        let formData = new FormData()
        formData.append('PropertyId',propertyId)
        formData.append('FloorPlanTypes',floorId)
      
        return await baseService.post(url,formData,{
          headers: {
          'accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
          },
        }
        )
        .then(data => {
          notify('Property added to cart', "success" , 3000)
            getAllBasket()
          return true
        })
        .catch(error => {
          if(error.response.data === "Property already added to cart by user")
            notify('Property already added to cart', "error" , 3000);
          else
                notify('Something went wrong try again later', "error", 3000);
            return false
        })
      }
      else
        notify('You need to select a floor plan', "error" , 3000);
        return false
    }
    else
      notify('You need to be logged in', "error" , 3000);
      return false
  } catch (error) {
    notify('Something went wrong try again later', "error" , 3000);
    return false
  }
}
const deleteBasketProperty = async(floorId,propertyId) => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/propertycart`;
  const formData = new FormData()
  formData.append('PropertyId', propertyId)
  formData.append('FloorPlanId',floorId)
  let response = await baseService.delete(url, {
      headers: {
          'accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: formData
  })
  if (response?.data) {
      let allFloorPlans = store.getState().dictionary.floorPlanTypes;
      let getFloorPlanName = allFloorPlans?.filter(f => f.id === floorId)[0]?.name;
      
      notify(`Removed ${getFloorPlanName} of property ${propertyId} from cart`, "success", 3000);
      return true
  }
  else {
      notify('Something went wrong try again later', "error", 3000);
      return false
  }
  
}

const deleteAllFloorsBasketProperty = async(propertyId) => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/propertycart/all`;
  const formData = new FormData()
  formData.append('PropertyId', propertyId)
  let response = await baseService.delete(url, {
      headers: {
          'accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: formData
  })
  if (response?.data) {
      notify(`Removed all floors of the property ${propertyId} from cart`, "success", 3000);
      return true
  }
  else {
      notify('Something went wrong try again later', "error", 3000);
      return false
  }
  
}
export { setPropertyDetails, setRecommendedProperties, postPropertyToCart, checkIfInCart , deleteBasketProperty,deleteAllFloorsBasketProperty}